import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=02b0e0e2&scoped=true&"
import script from "./favorite.vue?vue&type=script&lang=js&"
export * from "./favorite.vue?vue&type=script&lang=js&"
import style0 from "./favorite.vue?vue&type=style&index=0&id=02b0e0e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b0e0e2",
  null
  
)

export default component.exports